// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1TLxT","name":"Header_name__2XtVw","birthday":"Header_birthday__2cR3i","skeleton":"Header_skeleton__2VIiw"};